import { createSearchEngine } from '../engine';

const QUERY_PARAM = 'q';

export const bingSearch = createSearchEngine({
  safeParam: {
    key: 'adlt',
    value: 'strict',
  },
  isSearch: (url: URL): boolean => {
    return (
      /^(www\.)?bing\.com/.test(url.hostname) &&
      /^(\/videos|\/images|\/news)?(\/search)/.test(url.pathname) &&
      url.searchParams.has(QUERY_PARAM)
    );
  },
});
